import { ManagePoll } from '@live-webinar/poll-management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/polls/'].update({
        staticData: { title: { page: 'Content.Poll.PageHeading', forWebinar: true } },
        component: authGuard(ManagePoll, { canBroadcast: true })
    });
};
